import React from "react";
import PropTypes from "prop-types";
import { Route, Link } from "react-router-dom";

/* My version of a NavLink that handles the Bootstrap styling */

/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
const NavLink = ({
  to,
  exact,
  strict,
  location,
  activeClassName,
  className,
  linkClassName,
  activeStyle,
  style,
  isActive: getIsActive,
  "aria-current": ariaCurrent,
  ...rest
}) => {
  const path = typeof to === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  const escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  
  return (
    <Route
      path={escapedPath}
      exact={exact}
      strict={strict}
      location={location}
      children={({ location, match }) => {
          const isActive = !!(getIsActive ? getIsActive(match, location) : match);
          return (
            <li className={isActive ? [className, activeClassName].filter(i => i).join(" ") : className}>
              <Link className={linkClassName} to={to} aria-current={(isActive && ariaCurrent) || null} {...rest} />
            </li>
          );
        }}
    />
  );
};

NavLink.propTypes = {
  to: Link.propTypes.to,
  exact: PropTypes.bool,
  strict: PropTypes.bool,
  location: PropTypes.object,
  activeClassName: PropTypes.string,
  className: PropTypes.string,
  activeStyle: PropTypes.object,
  style: PropTypes.object,
  isActive: PropTypes.func,
  "aria-current": PropTypes.oneOf([
    "page",
    "step",
    "location",
    "date",
    "time",
    "true"
  ])
};

NavLink.defaultProps = {
  className: "nav-item",
  activeClassName: "active",
  linkClassName: "nav-link",
  "aria-current": "true"
};

export default NavLink;



// WEBPACK FOOTER //
// ./src/helpers/navlink.js